<template>
  <div class="f-col ctr notification">
    <transition-group name="slide-fade">
      <div
        class="f-row ctr toast"
        v-for="(message, id) in notifications"
        :key="`${message} ${id}`"
        @click="close(id)"
      >
        <span>{{ message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "Notification",
  computed: {
    notifications() {
      return this.$store.state.notifications;
    },
  },
  methods: {
    close(id) {
      this.$store.commit("POP_NOTIFICATION", id);
    },
  },
};
</script>

<style scoped>
.notification {
  position: fixed;
  top: 40px;
  align-self: center;
  width: 100%;
  margin: 0 auto;
  z-index: 10000;
  pointer-events: none;
}

.toast {
  cursor: pointer;
  margin: 5px 35px;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  border-radius: 0.3rem;
  color: #2e3e4e;
  background-color: #fff;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
  pointer-events: auto;
}

.slide-fade-enter-active {
  transition: all 300ms ease;
}

.slide-fade-leave-active {
  transition: all 300ms cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter {
  transform: translateX(-50px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(50px);
  opacity: 0;
}
</style>